import React from "react";
import { connect } from "react-redux";
import history from "../../history/history";
import { AddPill } from "./styles";
import { recordError } from "../../utils/commonUtil";
import PropTypes from "prop-types";
import { addLinkToPillDerivedStates } from "../selectors";

export const routeTo = props => {
  try {
    if (props.active) {
      history.push({
        pathname: props.linkPathname,
        state: { active: props.active }
      })
    } else {
      history.push(props.linkPathname);
    }
  }
  catch(error) {
    recordError(error);
  }
};

function AddLinkToPill(props) {
  if (!props.activeConfirmation) {
    return (
      <div className={`${props.styling}`} data-test="Addlink">
        <AddPill onClick={() => routeTo(props)}>
          <span>{props.buttonName}</span>
        </AddPill>
      </div>
    );
  }
  return null;
}

AddLinkToPill.propTypes = {
  active: PropTypes.any,
  activeConfirmation: PropTypes.bool,
  buttonName: PropTypes.string,
  linkPathname: PropTypes.string,
  styling: PropTypes.string
}

const mapStateToProps = state => ({
...addLinkToPillDerivedStates(state.toJS())

});

export default connect(
  mapStateToProps,
  null
)(AddLinkToPill);
